import { useAuthContext } from "../context/AuthContext";

/**
 * Local seam over the auth provider. Every component in the app should import
 * this instead of calling useAuth0() directly -- that keeps a future
 * auth-provider swap to a single file instead of every call site.
 *
 * As of the border-gateway migration this reads a React context instead of calling useAuth0()
 * directly, because which provider populates it (Auth0AuthBridge vs GatewayAuthBridge) is now a
 * runtime choice (AUTH_MODE) made once in App.js -- see context/AuthContext.js for why the
 * branch lives there and not in this hook.
 */
export function useAuth() {
  return useAuthContext();
}
